import moment from 'moment';

export function getCurrentDate(format = 'YYYY-MM-DD HH:mm:ss'): string {
  return moment().utcOffset(-5).format(format);
}
